import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { useIsInBottomSheet } from '../BottomSheet';
import { useDevice } from '../Device';
import { BaseTextField } from './BaseTextField/BaseTextField';
import { MobileTextField } from './MobileTextField';
// See note on BaseTextField — forwardRef + MUI types collapses BiProps' discriminated union.
const TextFieldImpl = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { mobile, validateInBottomSheet } = props, restProps = _object_without_properties(props, [
        "mobile",
        "validateInBottomSheet"
    ]);
    const { isMobileDevice } = useDevice();
    const isInBottomSheet = useIsInBottomSheet();
    if ((mobile === null || mobile === void 0 ? void 0 : mobile.renderAsCard) && isMobileDevice && !isInBottomSheet) {
        return /*#__PURE__*/ _jsx(MobileTextField, _object_spread_props(_object_spread({}, restProps), {
            mobile: mobile,
            validateInBottomSheet: validateInBottomSheet,
            ref: ref
        }));
    }
    const width = (mobile === null || mobile === void 0 ? void 0 : mobile.fluid) && isMobileDevice ? '100%' : restProps.width;
    return /*#__PURE__*/ _jsx(BaseTextField, _object_spread_props(_object_spread({}, restProps), {
        width: width,
        ref: ref
    }));
});
export const TextField = TextFieldImpl;
